import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  messageId: 0,
  makerName: "",
  userName: ""
};

const messageEntityModule = {
  state: {
    administrators: []
  },
  mutations: {
    fetchedAdministrators(state, {payload}) {
      state.administrators = payload
    }
  },
  actions: {
    administrators({ commit }, { }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .get(`maker_administrators/administrators`)
          .then((response) => {
            commit("fetchedAdministrators", {
              payload: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    read({ commit }, { pk }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/message/read/${pk}`, {
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    add({ commit }, { pk, addEntity }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/message/add/${pk}`, {
            ...addEntity
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    file({ commit }, { image }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .post(`/message/file`, {
            file: image
          })
          .then((response) => {
            resolve(response);
            // アップロード成功ダイアログ
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    administrators(state) {
      return state.administrators || [];
    }
  }
};

const messageListModule = {
  state: {
    // 自動返信設定
    onRequestFromAppValid: 0,
    // お問い合わせ
    inquiryType: 0,
    inquiry: "",
    open: false
  },
  mutations: {
    fetched(state, {payload}) {

      state.onRequestFromAppValid = payload.onRequestFromAppValid;
    },
    updated(state, payload) {
      state.open = false;
    },
    open(state) {
      state.open = true;
    },
    close(state) {
      state.open = false;
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    initialize(state) {
      state.onRequestFromAppValid = 0;
      state.inquiryType = 0;
      state.inquiry = "";
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    updateonRequestFromAppValid(state, { onRequestFromAppValid }) {
      state.onRequestFromAppValid = onRequestFromAppValid;
    },
    updateInquiryType(state, { inquiryType }) {
      state.inquiryType = inquiryType;
    },
    updateInquiry(state, { inquiry }) {
      state.inquiry = inquiry;
    }
  },
  actions: {
    // 自動返信設定の取得と変更
    fetchAutoReplySetting({ commit }, { }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .get(`/auto_reply`, {})
          .then((response) => {
            commit("fetched", {
              payload: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", {error});

            reject(error);
          });
      });
    },
    setAutoReplySetting({ commit, getters }, {  }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/auto_reply/edit`, {
            onRequestFromAppValid: getters.onRequestFromAppValid
          })
          .then((response) => {
            commit("updated", {});
            resolve(response);
          })
          .catch((error) => {
            commit("failed", {error});

            reject(error);
          });
      });
    },
    sendInquiry({ commit, getters }, { makerId }) {
        const store = this;
        return new Promise((resolve, reject) => {
          store.$axios
            .post(`/inquiry/send`, {
              makerId: makerId,
              inquiryType: getters.inquiryType,
              inquiry: getters.inquiry
            })
            .then((response) => {
              commit("updated", {
              });
              resolve(response);
            })
            .catch((error) => {
              commit("failed", { error });

              reject(error);
            });
        });
    }
  },
  getters: {
    open(state) {
      return state.open;
    },
    onRequestFromAppValid(state) {
      return state.onRequestFromAppValid;
    },
    inquiryType(state) {
      return state.inquiryType || "";
    },
    inquiry(state) {
      return state.inquiry || "";
    }
  }
};

const entityModule = entity("message", initialEntity);
const listModule = list("message");

export const message = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, messageListModule),
    entity: concatModules(entityModule, messageEntityModule)
  }
};
